import { defineSlotRecipe } from '@chakra-ui/react';
import { toastAnatomy } from '@chakra-ui/react/anatomy';

export const toastSlotRecipe = defineSlotRecipe({
  slots: toastAnatomy.keys(),
  base: {
    root: {
      py: '3',
      px: '4',
      '&[data-type=error]': {
        bg: '{colors.red.100}',
        color: '{colors.neutral.500}',
      },
      '&[data-type=success]': {
        bg: '{colors.green.100}',
        color: '{colors.neutral.500}',
      },
      '&[data-type=warning]': {
        bg: '{colors.orange.100}',
        color: '{colors.neutral.500}',
      },
    },
    title: {
      fontSize: 'md',
      fontWeight: 'medium',
    },
    description: {
      fontSize: 'sm',
      fontWeight: 'normal',
    },
    closeTrigger: {
      color: '{colors.neutral.500}',
    },
  },
});
